import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { X } from 'lucide-react';
import * as Icons from 'lucide-react';
import s from '../../styles/components/rewards/RewardsToast.module.css';
import site from '../../data/master.json';
import { useSiteStore } from '../../utils/store/useSiteStore';

export default function RewardsToast() {
  const { label, text, icon } = site.rewardsToast;
  const toastExpanded = useSiteStore((state) => state.toastExpanded);
  const setToastExpanded = useSiteStore((state) => state.setToastExpanded);
  const toastAnimated = useSiteStore((state) => state.toastAnimated);
  const setToastAnimated = useSiteStore((state) => state.setToastAnimated);

  useEffect(() => {
    const timer = setTimeout(() => {
      setToastAnimated();
    }, 800);
    return () => clearTimeout(timer);
  }, []);
  const navigate = useNavigate();
  const Icon = Icons[icon];

  return (
    <div
    className={`${s.container} ${toastExpanded ? s.containerExpanded : ''} ${!toastAnimated ? 'rewards-toast-enter' : ''}`}
      onClick={() => toastExpanded ? navigate('/rewards') : setToastExpanded(true)}
    >
      <div className={s.pulseRing} />
      <div className={s.pulseRing2} />
      <div className={s.dot}>
        {Icon && <Icon size={18} color="#fff" />}
      </div>
      <div className={`${s.content} ${toastExpanded ? s.contentVisible : ''}`}>
        <span className={s.contentLabel}>{label}</span>
        <span className={s.contentText}>{text}</span>
      </div>
      {toastExpanded && (
        <button
          className={s.dismiss}
          onClick={(e) => { e.stopPropagation(); setToastExpanded(false); }}
        >
          <X size={12} color="#666" />
        </button>
      )}
    </div>
  );
}